/* Totes snag fix, 11 Oct 2026 (AIDC-11146 QA note a): the theme's main "Add to cart" now carries the initials and the 4.00 personalisation fee,
   same as the widget's own button. The widgets wrote properties[Initials] into the first /cart/add form on the page (the Shop Pay instalments form), not the product form.
   Loaded by the CFC and AF personalisation sections; does nothing on pages without the initials box. */
(function () {
  if (window.__cfcMainFormFix) return;
  window.__cfcMainFormFix = true;
  document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('cfcPersonalText');
    var form = document.querySelector('product-form form');
    if (!input || !form) return;

    var field = form.querySelector('input[name="properties[Initials]"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'properties[Initials]';
      form.appendChild(field);
    }
    function initials() { return input.value.trim().toUpperCase(); }
    function sync() { field.value = initials(); field.disabled = !field.value; }      // a blank property is not sent at all
    input.addEventListener('input', sync);
    sync();

    function feeVariant() {
      if (window.AF_CONFIG && window.AF_CONFIG.PERSONALIZATION_FEE_VARIANT_ID) return window.AF_CONFIG.PERSONALIZATION_FEE_VARIANT_ID;
      if (window.CFC_CONFIG && window.CFC_CONFIG.PERSONALIZATION_FEE_VARIANT_ID) return window.CFC_CONFIG.PERSONALIZATION_FEE_VARIANT_ID;
      return null;
    }

    /* With initials typed, add the fee first, then let the theme's own submit run (it adds the item with properties[Initials] and refreshes the cart). */
    form.addEventListener('submit', function (e) {
      if (form.dataset.cfcFeeAdded === '1') { delete form.dataset.cfcFeeAdded; return; }
      var fee = feeVariant();
      if (!initials() || !fee) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var body = new FormData();
      body.append('id', fee);
      body.append('quantity', '1');
      fetch('/cart/add.js', { method: 'POST', body: body })
        .then(function (r) { if (!r.ok) throw new Error('fee add failed'); })
        .then(function () {
          form.dataset.cfcFeeAdded = '1';
          form.requestSubmit(e.submitter || undefined);
        })
        .catch(function (err) {
          console.error('Personalisation fee not added', err);
          alert('Sorry, we could not add the personalisation. Please try again.');
        });
    }, true);
  });
})();
